export enum Step {
  CommunityCreationExperience = 'CommunityCreationExperience',
  CommunityCreationChallenges = 'CommunityCreationChallenges',
  CommunityCreationObjective = 'CommunityCreationObjective',
  Success = 'Success'
}

export const PROGRESS_BAR_VALUE_CREATION_CHALLENGES_STEP = 40

export const PROGRESS_BAR_VALUE_CREATION_OBJETIVE_STEP = 80

export const PROGRESS_BAR_VALUE_CREATION_EXPERIENCE_STEP = 0

export enum CreationCommunitySurveyQuestionDatahubLabel {
  Question1 = 'Como foi para você criar uma comunidade no Hotmart Club?',
  Question2 = 'O que foi difícil em criar uma comunidade?',
  Question3 = 'Qual foi seu principal objetivo em criar uma comunidade?'
}
